var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27 12H5V7h3v2.94h2V7h12v2.94h2V7h3v5zm1-7h-4V3h-2v2H10V3H8v2H4a1 1 0 00-1 1v8h26V6a1 1 0 00-1-1zM27 27H5V16H3v12a1 1 0 001 1h24a1 1 0 001-1V16h-2v11z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18h4M8 23h4M14 18h4M14 23h4M20 18h4M20 23h4",
    stroke: props.color,
    strokeWidth: 2
  })));
}

export default SvgIconCalendar;